import { isPlatformServer } from '@angular/common';
import { DOCUMENT, Injectable, PLATFORM_ID, inject } from '@angular/core';

import { ConnectionConfig, GeolocationConfig } from '@frontend/sports/common/client-config-data-access';
import { OnFeatureInit } from '@frontend/vanilla/core';

import { RunAfterLcpService } from '../perf-cdk/run-after-lcp.service';

@Injectable({ providedIn: 'root' })
export class GeoLocationAssetService implements OnFeatureInit {
    private readonly geoConfig = inject(GeolocationConfig);
    private readonly connectionConfig = inject(ConnectionConfig);
    private readonly afterLcpService = inject(RunAfterLcpService);
    private readonly _doc = inject(DOCUMENT);
    private readonly isServer = isPlatformServer(inject(PLATFORM_ID));

    onFeatureInit(): void | Promise<any> {
        this.bootstrapLegacy();
    }

    bootstrapLegacy() {
        if (!this.isServer && this.geoConfig.isGeolocationEnabled && this.geoConfig.bootstrapAssetPaths?.length > 0) {
            this.afterLcpService.runAfterLcp(() => {
                if (this.geoConfig.geoPollingUrlPath) {
                    const pollingUrl = this.geoConfig.geoPollingUrlPath
                        .replace(`{channel}`, this.geoConfig.coordinatorSettings.channelId)
                        .replace(`{env}`, this.geoConfig.coordinatorSettings.environment)
                        .replace(`{plcIdentifier}`, this.geoConfig.coordinatorSettings.plcIdentifier)
                        .replace('{accessId}', this.connectionConfig.publicAccessId ?? this.connectionConfig.pushAccessId);
                    this.geoConfig.bootstrapAssetPaths.forEach((asset) => {
                        const script = this._doc.createElement('script');
                        script.type = 'text/javascript';
                        script.src = `${asset.replace('{geoPollingUrlPath}', pollingUrl)}`;
                        // we cannot defer jquery, as gcoobee depends on it
                        const async = !asset.includes('jquery');
                        script.async = async;
                        script.defer = async;
                        this._doc.head.append(script);
                    });
                }
            });
        }
    }
}
